import * as Types from '../../../util/graphql/api.graphql';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';

export const GetTaskDocument = gql`
  query GetTask($id: String!) {
    task(id: $id) {
      id
      __typename
      code {
        coding {
          system
          code
        }
      }
      status
      intent
      for {
        reference
      }
      note {
        text
      }
      lastModified
      input {
        type {
          text
          coding {
            system
            code
          }
        }
        valueReference {
          reference
        }
      }
      output {
        type {
          text
          coding {
            system
            code
          }
        }
        valueString
      }
    }
  }
`;

/**
 * __useGetTaskQuery__
 *
 * To run a query within a React component, call `useGetTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetTaskQueryResponse,
    GetTaskQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetTaskQueryResponse, GetTaskQueryVariables>(
    GetTaskDocument,
    baseOptions,
  );
}
export function useGetTaskLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetTaskQueryResponse,
    GetTaskQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    GetTaskQueryResponse,
    GetTaskQueryVariables
  >(GetTaskDocument, baseOptions);
}
export type GetTaskQueryHookResult = ReturnType<typeof useGetTaskQuery>;
export type GetTaskLazyQueryHookResult = ReturnType<typeof useGetTaskLazyQuery>;
export type GetTaskQueryResult = ApolloReactCommon.QueryResult<
  GetTaskQueryResponse,
  GetTaskQueryVariables
>;
export type GetTaskQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;

export type GetTaskQueryResponse = {
  __typename: 'Query';
  task?: Types.Maybe<{
    __typename: 'Task';
    id?: Types.Maybe<string>;
    status: Types.TaskStatus;
    intent: string;
    lastModified?: Types.Maybe<string>;
    code?: Types.Maybe<{
      __typename: 'CodeableConcept';
      coding?: Types.Maybe<
        Array<{
          __typename: 'Coding';
          system?: Types.Maybe<string>;
          code?: Types.Maybe<string>;
        }>
      >;
    }>;
    for?: Types.Maybe<{
      __typename: 'Reference';
      reference?: Types.Maybe<string>;
    }>;
    note?: Types.Maybe<
      Array<{ __typename: 'Annotation'; text?: Types.Maybe<string> }>
    >;
    input?: Types.Maybe<
      Array<{
        __typename: 'TaskInput';
        type: {
          __typename: 'CodeableConcept';
          text?: Types.Maybe<string>;
          coding?: Types.Maybe<
            Array<{
              __typename: 'Coding';
              system?: Types.Maybe<string>;
              code?: Types.Maybe<string>;
            }>
          >;
        };
        valueReference?: Types.Maybe<{
          __typename: 'Reference';
          reference?: Types.Maybe<string>;
        }>;
      }>
    >;
    output?: Types.Maybe<
      Array<{
        __typename: 'TaskOutput';
        valueString?: Types.Maybe<string>;
        type: {
          __typename: 'CodeableConcept';
          text?: Types.Maybe<string>;
          coding?: Types.Maybe<
            Array<{
              __typename: 'Coding';
              system?: Types.Maybe<string>;
              code?: Types.Maybe<string>;
            }>
          >;
        };
      }>
    >;
  }>;
};
